import { defineComponent as _defineComponent } from 'vue'
import { useField } from "vee-validate";
import { ExclamationCircleIcon, XCircleIcon } from "@heroicons/vue/solid";
import BaseInput from "./_base.vue";

interface Props {
    type?: string;
    value?: string | number;
    name: string;
    label: string;
    placeholder: string;
    autocomplete?: string;
    required?: boolean;
    locked?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'input',
  props: {
    type: { type: String, required: false, default: "text" },
    value: { type: [String, Number], required: false, default: undefined },
    name: { type: String, required: true, default: undefined },
    label: { type: String, required: true, default: undefined },
    placeholder: { type: String, required: true, default: undefined },
    autocomplete: { type: String, required: false, default: "" },
    required: { type: Boolean, required: false, default: false },
    locked: { type: Boolean, required: false, default: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
} = useField(props.name, undefined, {
    initialValue: props.value,
});

function customHandleChange(e: Event) {
    const target = e.target;
    if (props.type === "number") {
        // @ts-ignore
        handleChange(Number(target?.value));
    } else {
        handleChange(e);
    }
}

const __returned__ = { props, inputValue, errorMessage, handleBlur, handleChange, meta, customHandleChange, get ExclamationCircleIcon() { return ExclamationCircleIcon }, BaseInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})